<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">Cancel</ion-button>
      </ion-buttons>
      <ion-title>Salva firma</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm" :strong="true">Confirm</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content ref="content" class="relative" style="--background: transparent">
    <div :style="`opacity: ${loadingSize ? '0': '1'}`">
      <div ref="signatureBox" class="signature-box ">
        <div class="ion-margin-bottom ion-padding-horizontal">
          <ion-label>Firma</ion-label>
        </div>
      </div>
    </div>
    <div v-show="loadingSize" slot="fixed" class="loader">
      <ion-spinner color="primary"></ion-spinner>
    </div>
  </ion-content>
</template>

<script setup lang="ts">
import {
  IonSpinner,
  IonButton,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonLabel,
  IonContent,
  modalController
} from "@ionic/vue";
import {onMounted, ref} from "vue";
import SignaturePad from "signature_pad";
import {ScreenOrientation, OrientationType, ScreenOrientationChange} from '@capawesome/capacitor-screen-orientation';


const loadingSize = ref(true);
const content = ref<HTMLElement | null>(null);
const signatureBox = ref<HTMLCanvasElement | null>(null);
// const signatureCanvas = ref<HTMLCanvasElement | null>(null);
let signaturePad: SignaturePad | null = null;

const initializePad = () => {
  if (signatureBox.value) {
    const signaturePadEl = signatureBox.value.querySelector('canvas');
    if (signaturePadEl) {
      signaturePadEl.remove();
      signaturePad = null;
    }
  }
  try {
    // @ts-ignore
    content.value!.$el.getScrollElement().then((scrollElement) => {
      const clientWidth = scrollElement.clientWidth
      const clientHeight = scrollElement.clientHeight;
      const element = document.createElement('canvas');
      signatureBox.value!.style.height = clientHeight + 'px';
      element.id = 'signature-pad';
      element.width = clientWidth;
      element.height = clientWidth / 19 * 9;
      element.style.backgroundColor = 'white';
      element.style.borderBottom = '1px solid var(--ion-color-step-200)';
      //element.height = clientHeight;
      signatureBox.value!.appendChild(element);
      /* signatureCanvas.value!.style.width = clientWidth + 'px';
       signatureCanvas.value!.style.minWidth = clientWidth + 'px';
       signatureCanvas.value!.style.minHeight = clientHeight + 'px';
       signatureCanvas.value!.style.height = clientHeight + 'px';*/
      signaturePad = new SignaturePad(element, {
        penColor: "rgb(0, 0, 0)",
        dotSize: element.width / 1000
      });
      loadingSize.value = false
    });
  } catch (e: any) {}
}

onMounted(async () => {
  setTimeout(() => {
    initializePad();
  }, 500);
  ScreenOrientation.addListener('screenOrientationChange', (change: ScreenOrientationChange) => {
    loadingSize.value = true
    window.setTimeout(() => {
      initializePad();
      loadingSize.value = false
    }, 500)
  });
})

const cancel = () => {
  return modalController.dismiss(null, 'cancel');
}
const confirm = () => {
  if (signaturePad) {
    return modalController.dismiss(signaturePad.toDataURL(), 'confirm');
  }
}
</script>

<style scoped>
.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 9;
  color: var(--ion-color-step-200);
}

.signature-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  background-color: black;
}
</style>
